import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="py-16 px-4 bg-gradient-to-b from-transparent to-black/30" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <div className="border-l-4 border-amber-500 pl-6 py-4" data-id="element-122">
          <p className="text-lg md:text-xl leading-relaxed text-gray-200" data-id="element-123">
            ¿Alguna vez has sentido que por más que te esfuerces en este país,
            el dinero nunca es suficiente? Trabajas 10, 12 horas... llegas a
            casa con dolor de espalda, te duchas y al día siguiente lo mismo.
            Mientras tanto, ves a gente en internet ganando en una hora lo que
            tú ganas en una semana.{' '}
            <span className="text-amber-400 font-semibold" data-id="element-124">
              ¿Cuál es el secreto?
            </span>{' '}
            No es que sean más inteligentes que tú.{' '}
            <span className="text-amber-400 font-semibold italic" data-id="element-125">
              Es que ellos tienen un sistema que tú aún no conoces.
            </span>
          </p>
        </div>
      </div>
    </motion.section>;
}